import { createAsyncThunk } from "@reduxjs/toolkit";
import { setErrorSnackBarMessage, setSnackBarMessage } from "../systemSlice";
import { errorToHandler } from "../../api/error";
import { api } from "api";
import { ApiError, CreateIdentityProviderRequest } from "api/controlPlaneApi";

export const fetchIdentityProviders = createAsyncThunk(
  "identityProviders/fetchIdentityProviders",
  async (_, { rejectWithValue, getState, dispatch }) => {
    return api.authentication
      .listIdentityProviders()
      .then((res) => {
        return res.data.results;
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const fetchIdentityProviderDetails = createAsyncThunk(
  "identityProviders/fetchIdentityProviderDetails",
  async (
    identityProviderID: string,
    { rejectWithValue, getState, dispatch },
  ) => {
    return api.authentication
      .getIdentityProvider(identityProviderID)
      .then((res) => {
        return res.data;
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const deleteIdentityProvider = createAsyncThunk(
  "identityProviders/deleteIdentityProvider",
  async (
    identityProviderID: string,
    { rejectWithValue, getState, dispatch },
  ) => {
    return api.authentication
      .deleteIdentityProvider(identityProviderID)
      .then(() => {
        dispatch(setSnackBarMessage("Identity Provider deleted successfully"));
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const addIdentityProvider = createAsyncThunk(
  "identityProviders/addIdentityProvider",
  async (
    identityProvider: CreateIdentityProviderRequest,
    { rejectWithValue, getState, dispatch },
  ) => {
    return api.authentication
      .createIdentityProvider(identityProvider)
      .then(() => {
        dispatch(setSnackBarMessage("Identity Provider added successfully"));
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);

export const editIdentityProvider = createAsyncThunk(
  "identityProviders/editIdentityProvider",
  async (identityProvider: any, { rejectWithValue, getState, dispatch }) => {
    let id = identityProvider.id;
    delete identityProvider.id;
    return api.authentication
      .updateIdentityProvider(id, identityProvider)
      .then(() => {
        dispatch(setSnackBarMessage("Identity Provider updated successfully"));
      })
      .catch(async (res) => {
        const err = (await res.json()) as ApiError;
        dispatch(setErrorSnackBarMessage(errorToHandler(err)));
        return rejectWithValue(res);
      });
  },
);
